import endpoints from './endpoints';

const host = 'https://www.posillicocms.com';
const api = 'https://posillico-cms-prod-5e570cebba67.herokuapp.com';

export default {
	host,
	api,

	bucket: 'https://posillicocmsstorage.blob.core.windows.net/production',

	// TODO :: add GET so we don't have to do "setFeatureFlags" etc...
	endpoints: endpoints(api),
};
